import { Badge } from "@chakra-ui/react";
import { FundFamilySetupTabProps } from "features/fund-family/setup/FundFamilySetupTabProps";
import { useNoticeSchemaRetrieveSuspense } from "gen/endpoints/notice-schema/notice-schema";
import { useOutletContext } from "react-router-dom";
import {
  ContentBlock,
  ContentBlockBody,
  ContentBlockGroup,
  ContentBlockHeader,
  ContentBlockTitle,
} from "shared/components/content/ContentBlock";
import { PageTabBody } from "shared/components/layout/PageTabBody";

export const FundFamilySetupNoticesTabSchema: React.FC = () => {
  const { fundFamilyId } = useOutletContext<FundFamilySetupTabProps>();
  const { data: noticeSchemaData } =
    useNoticeSchemaRetrieveSuspense(fundFamilyId);

  const result = Object.entries(noticeSchemaData.schemas).map(
    ([schemaName, schemaProperties]) => (
      <ContentBlock key={`${schemaName}_block`}>
        <ContentBlockHeader>
          <ContentBlockTitle key={`${schemaName}_title`}>
            {schemaName}
          </ContentBlockTitle>
        </ContentBlockHeader>
        <ContentBlockBody>
          {schemaProperties.map((schemaProperty) => (
            <Badge
              key={`${schemaName}_${schemaProperty}`}
              margin="2px"
            >{`{{ ${schemaProperty} }}`}</Badge>
          ))}
        </ContentBlockBody>
      </ContentBlock>
    ),
  );

  return (
    <PageTabBody>
      <ContentBlockGroup>{result}</ContentBlockGroup>
    </PageTabBody>
  );
};
